import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export const BlockSectionRoot = forwardRef<
  HTMLDivElement,
  ComponentPropsWithRef<"div">
>(({ className, children, ...rest }, ref) => (
  <div
    ref={ref}
    className={classNames("wb-relative", className)}
    data-block-root
    {...rest}
  >
    {children}
  </div>
));

BlockSectionRoot.displayName = "BlockSectionRoot";
